import React from "react";
import { Link } from "react-router-dom";
import { RewardCard, RewardContainer } from "./Reward.styled";

const Reward = () => {
  return (
    <RewardContainer>
      <RewardCard>
        <p>
          Pubmining reward program is a way to earn additional income by
          inviting others to join the platform. The reward program works in the
          following way: As a user, you receive a unique invite link that you
          can share with your friends and family.
        </p>

        <p>
          When someone signs up using your invite link, they become your
          referral and you earn a bonus reward of 50 TRX.
        </p>

        <p>
          Your referral will also receive a bonus of 50 TRX for signing up using
          your invite link.
        </p>

        <p>
          You can earn additional referral bonuses when your referrals make a
          deposit and purchase a mining machine.
        </p>

        <p>
          You will receive a 7% commission on the daily earnings of your level 1
          referrals, a 5% commission on the daily earnings of your level 2
          referrals, and a 2% commission on the daily earnings of your level 3
          referrals.
        </p>

        <p>
          The referral earnings will be added to your account balance every 24
          hours.
        </p>

        <p>
          Users can also claim up to 20,000 TRX bonuses with the claim reward
          program. Users will be able to claim at least 50 TRX every time a new
          downline join with their link and buy at least 1 machine. The more
          active downlines you have, the more you will be eligible to claim
          rewards.
        </p>

        <p>
          By inviting more people to join Pubmining, you can earn more referral
          bonuses and increase your passive income on the platform.
        </p>

        <Link style={{ marginInline: "auto" }} to={"/"}>
          Home
        </Link>
      </RewardCard>
    </RewardContainer>
  );
};

export default Reward;
